import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {CCol} from "@coreui/react";
import React from "react";

const SortableColumn = ({ column, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: column.id,
        data: { type: 'column', columnId: column.id },
    })
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.7 : 1,
    }
    return (
        <CCol md={4} ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {children}
        </CCol>
    )
}

export default SortableColumn;